import { useState } from 'react'

import CollapsibleCard from '@/components/Elements/CollapsibleCard'
import { initialTenderDocument } from '@/features/offerCostBudgets/constants/offerCostBudget.constant'
import { showCostBudgetWorkflowModal } from '@/features/offers/slices/offerModal.slice'
import { Badge, Button, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text, Tooltip } from '@chakra-ui/react'
import { TenderDocumentStatus } from '@eapproval/offer-shared'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useCostBudgetAccess } from '../CostBudgetAccessProvider'
import CostBudgetTenderDocumentCard from './CostBudgetTenderDocumentCard'

const renderStatusBadge = (status) => {
  let badgeColor = 'gray.100'
  switch (status) {
    case 'draft':
      badgeColor = 'gray.100'
      break
    case 'submitted':
      badgeColor = 'yellow'
      break
    case 'posted':
      badgeColor = 'green'
      break
  }

  return <Badge bg={badgeColor}>{status}</Badge>
}
const CostBudgetTenderDocumentSection = ({ costBudgetIndex = -1 }) => {
  const {
    fields: tenderDocuments,
    append: addTenderDocument,
    remove: removeTenderDocument,
  } = useFieldArray({ name: `sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments` })

  const [tenderDocumentTabIndex, setTenderDocumentTabIndex] = useState(tenderDocuments.length - 1)
  const { getValues } = useFormContext()
  const dispatch = useDispatch()
  const { canAddTenderDocument, canOpenWorkflowChat, canActionWorkflowChat } = useCostBudgetAccess()

  const handleAddTenderDocument = (e) => {
    e.stopPropagation()
    // toast.info('Added New TenderDocument')

    //Load Previous Quotation Detail template

    const latestTenderDocument = tenderDocuments[tenderDocuments.length - 1]

    addTenderDocument({ ...initialTenderDocument, quotationTemplate: latestTenderDocument?.quotationTemplate })
    setTenderDocumentTabIndex(tenderDocuments.length)
  }

  const handleOpenWorkflowChatModal = (e) => {
    e.stopPropagation()

    const issues = getValues(`sourcing.costBudgets.${costBudgetIndex}.detail.workflow.issues`)
    const workflowStatus = getValues(`sourcing.costBudgets.${costBudgetIndex}.detail.workflow.status`)
    const offerId = getValues('_id')
    const costBudgetId = getValues(`sourcing.costBudgets.${costBudgetIndex}.detail._id`)

    if (!offerId || offerId === '') {
      return
    }

    if (!costBudgetId || costBudgetId === '') {
      return
    }

    if (!Array.isArray(issues)) {
      return
    }

    dispatch(
      showCostBudgetWorkflowModal({
        issues: issues,
        offerId: offerId,
        costBudgetId: costBudgetId,
        workflowStatus: workflowStatus,
        canAction: canActionWorkflowChat,
      })
    )
  }

  return (
    <CollapsibleCard
      title="Tender Documents"
      defaultIsOpen={true}
      rightElement={
        <Flex gap="2">
          {canAddTenderDocument && (
            <Button colorScheme={'green'} onClick={handleAddTenderDocument}>
              Add Addendum
            </Button>
          )}
          {canOpenWorkflowChat && (
            <Button colorScheme={'green'} onClick={handleOpenWorkflowChatModal}>
              Open Workflow
            </Button>
          )}
        </Flex>
      }
    >
      <Tabs
        size="md"
        colorScheme={'teal'}
        variant="enclosed"
        index={tenderDocumentTabIndex}
        isLazy
        onChange={(index) => {
          setTenderDocumentTabIndex(index)
        }}
      >
        <TabList w="100%">
          {tenderDocuments.map((tenderDocument, tenderDocumentIndex) => {
            const displayName = tenderDocumentIndex === 0 ? 'Tender' : `Addendum ${tenderDocumentIndex}`
            let textColor = 'black'
            switch (tenderDocument.status) {
              case TenderDocumentStatus.INACTIVE:
                textColor = 'gray'
                break
              case TenderDocumentStatus.DRAFT:
                textColor = 'black'
                break
              case TenderDocumentStatus.POSTED:
                textColor = 'green'
                break
              case TenderDocumentStatus.SUBMITTED:
                textColor = 'blue.400'
                break
            }
            return (
              <Tab
                key={'tenderDocumentTab' + tenderDocumentIndex}
                fontWeight={'bold'}
                color={textColor}
                // _hover={{ color: 'teal' }}
                as={Flex}
                gap="2"
              >
                <Tooltip label={`(${tenderDocument.status})`}>
                  <Text>{displayName}</Text>
                </Tooltip>
              </Tab>
            )
          })}
        </TabList>
        <TabPanels>
          {tenderDocuments.length > 0 &&
            tenderDocuments.map((tenderDocument, tenderDocumentIndex) => (
              <TabPanel key={'tenderTabPanel' + tenderDocumentIndex}>
                <CostBudgetTenderDocumentCard
                  isOpen={tenderDocuments.length - 1 === tenderDocumentIndex}
                  costBudgetIndex={costBudgetIndex}
                  tenderDocument={tenderDocument}
                  tenderDocumentIndex={tenderDocumentIndex}
                  removeTenderDocument={removeTenderDocument}
                />
              </TabPanel>
            ))}
        </TabPanels>
      </Tabs>
    </CollapsibleCard>
  )
}

export default CostBudgetTenderDocumentSection
